export const initState = {
  backPageModule: null,
  currentPeriod: 5,
  version: "year-end-2022", //version that agent is looking at
  //version: "mq3", //version that agent is looking at
  //version: "qv4",
  mailingVersion: "q", //version that we gonna print
  pdfPrintVersion: "mq",
  typeOfMQVersion: "mq2",
  typeOfQVersion: "qv4",
  typeOfVersion: "mq2",
  typeOfYEVersion: "ye2",
  pmaMailerDataLoaded: false,
  currentStep: 0,
  currentArea: {},
  missionStatement: null,
  showDataVerification: true,
  currentAreaFirstMailProID: 0,
  recentlyUpdatedMailProID: null,
  isLoading: false,
  hoSearch: "",
  hoFilter: "active", //filter by active by default
  hoQuickFilter: "",
  hoAdvanceFilter: "",
  advanceFilterOptionData: null,
  viewingGeneratedCL: true,
  mailProHeader: "homeValuation",
  mailProSortDirection: "desc",
  propertyData: [],
  MQCityDetails: [],
  mlsAreaObjects: [],
  getSingleHOData: [],
  marketActivity: [],
  mlsAreas: [],
  quarterlyAreaTable: [],
  quarterlyCityTable: [],
  propertyPhotoDetailsDTO: [],
  localSellingAgents: [],
  dataVerification: [],
  coverPageDetails: null,
  nextPMAPrintDate: null,
  singleHOData: [],
  testimonials: null,
  agentDesignations: null,
  agentAdvantages: null,
  salePriceForCities: null,
  oldPhotoDetails: [],
  yearEnd: null,
  qArea: null,
  qCity: null,
  aprilData: null,
  pmaQuarterlyCombinedCityDTO: null,
  explicitEnableNewMailProInit: false, // whether explict show new mailpro init dialog or not
  disableNewMailingForCurrentSession: false,
  newMailProInitDialogMode: null,
  newMailingMailProData: [],
  newMailingEditedData: [],
  quadrantModalOpen: false,
  agentFocusModalOpen: false,
  designDetailsSpecificModalOpen: false,
  missionStatementModalOpen: false,
  photoCheckboxModalOpen: false,
  recentActivityPhotoList: null,
  oldRecentActivityPhotoList: null,
  quadrantDetails: [],
  agentFocusInfoList: [],
  designDetailsInfoList: [],
  tpTrends2WatchList: null,
  keyMarketAvgsList: null,
  miniTableDetailsDTO: null,
  priceRangeDashBoardDetailsDTOArea: null,
  priceRangeDashBoardDetailsDTOCity: null,
  volunteerDetails: [],
  volunteerList: [],
  localEventsDetails: [],
  localEventsList: [],
  qrCodeMailerProID: "",
  agentData: null,
  altAgentData: null,
};
